import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { IGetQuery, ISearchResponse2 } from 'ets-fe-ng-sdk';
import { BaseService } from '@Services/base.service';

@Injectable({
  providedIn: 'root',
})
export class DocumentationTableFieldsService extends BaseService {
  readonly baseURL = environment.gatewayBaseURL + `/reports/tables/dictionary/`;
  search(
    query: IGetQuery<{
      description: string;
      fieldName: string;
      tableName: string;
    }>,
  ) {
    return this.get<ISearchResponse2<ITableFieldDocumentation>>('search', query);
  }
  searchLite(
    query: IGetQuery<{
      description: string;
      fieldName: string;
      tableName: string;
    }>,
  ) {
    query.pageNumber = query.pageNumber || 1;
    query.pageSize = query.pageSize || 1000000;
    return this.apiS.get<ISearchResponse2<ITableFieldDocumentationLite>>(
      environment.apiBaseUrl + '/rest/tables/field-name/description',
      query,
    );
  }

  save(data: ITableFieldDocumentation[]) {
    debugger;
    return this.post(
      {
        tableDictionaryBulkRequestList: data.map((tableDictionary) => ({
          requestId: this.uS.generateUUID(),
          tableDictionary,
        })),
      },
      'bulk',
    );
  }

}

export interface ITableFieldDocumentation {
  authBy?: string;
  authOn?: string;
  createdBy?: string;
  createdOn?: string;
  description?: string;
  fieldName: string;
  id?: number;
  tableName?: string;
  updatedBy?: string;
  updatedOn?: string;
  users?: string;
  dates?: string;
}

export type ITableFieldDocumentationLite = Pick<ITableFieldDocumentation, 'description' | 'fieldName'>;
